<template>
  <div>
    <!-- formulario del Resource -->
    <v-form ref="formDatosResource" lazy-validation>
      <v-dialog v-model="estadoComp" persistent scrollable max-width="60%">
        <v-card>
          <v-card-title class="btn_otro py-5 mb-2">
            <v-row class="py-0">
              <v-icon class="pr-2" dark>fa-upload</v-icon>
              {{ formTitle }}
              <v-spacer></v-spacer>
              <v-btn fab dark x-small class="btn_style3" @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" md="5" lg="6" v-if="parametros.evento == 'add'">
                <v-select label="Tipo de recurso" v-model="data.id_tipo_recurso" :items="listTipoRecurso"
                  @change="EventTypeResource(data.id_tipo_recurso)" item-value="id" item-text="descripcion"
                  :rules="[rul.selectReq]">
                </v-select>
              </v-col>
              <v-col cols="12" md="5" lg="6">
                <v-select label="Acceso" cols="6" v-model="data.id_acceso" :items="listAcceso" item-value="id"
                  item-text="descripcion" :rules="[rul.selectReq]">
                </v-select>
              </v-col>

              <v-col cols="12" md="5" lg="6">
                <v-select label="Nivel" cols="6" v-model="data.id_nivel" small :items="listNivel" item-value="id"
                  item-text="desc_nivel" @change="EventNivel(data)" :rules="[rul.selectReq]">
                </v-select>
              </v-col>

              <v-col cols="12" md="5" lg="6">
                <v-select label="Área" cols="6" v-model="data.id_area" :items="listArea" item-value="id"
                  item-text="desc_area" :rules="[rul.selectReq]">
                </v-select>
              </v-col>

              <v-col cols="12" md="5" lg="6" v-if="parametros.evento == 'add'">
                <template v-if="data.id_tipo_recurso == 'img'">
                  <v-file-input v-model="data.archivos" label="Imágenes (png, jpg o gif)" @change="OnArchivoChange"
                    :rules="[rul.required, rul.max5Mb, rul.imgReq]" chips multiple counter show-size
                    prepend-icon="fa-regular fa-image" accept=".png, .jpg, .gif">
                  </v-file-input>
                </template>

                <template v-if="data.id_tipo_recurso == 'doc'">
                  <v-file-input v-model="data.archivos" label="Documentos (doc docx o pdf)" @change="OnArchivoChange"
                    :rules="[rul.required, rul.max5Mb]" chips multiple counter show-size accept=".doc, .docx, .pdf ">
                  </v-file-input>
                </template>

                <template v-if="data.id_tipo_recurso == 'vid'">
                  <v-file-input v-model="data.archivos" label="Videos (mp4 o avi)" @change="OnArchivoChange"
                    :rules="[rul.required, rul.max100Mb]" chips multiple counter show-size
                    prepend-icon="fa-solid fa-file-video" accept="video/*">
                  </v-file-input>
                </template>

                <template v-if="data.id_tipo_recurso == 'aud'">
                  <v-file-input v-model="data.archivos" label="Audios (mp3)" @change="OnArchivoChange"
                    :rules="[rul.required, rul.max5Mb]" chips multiple counter show-size
                    prepend-icon="fa-solid fa-file-audio" accept="audio/*">
                  </v-file-input>
                </template>
              </v-col>

              <v-col cols="12" md="5" lg="6" v-if="parametros.evento == 'edit'">
                <v-text-field label="Nombre del archivo" v-model="data.file_desc" :rules="[rul.required]"></v-text-field>
              </v-col>
            </v-row>

            <v-row class="pt-0" v-if="componenteEvento.agregar_submodulo">
              <v-col class="d-flex flex-row-reverse pt-0">
                <v-btn class="btn_block_style2" :loading="saving" dark  @click="SaveItem()"><v-icon left>fas fa-save</v-icon> Guardar recurso</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-form>
    <!-- fin modal del Resourse -->
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "resource",

  props: {
    parametros: {
      type: Object,
    },
    estadoComp: {
      type: Boolean,
    },
  },

  components: {},
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 22, id_modulo: 4 }, //sud_modulo y modulo
    datoLogin: sessionStorage, // variables de sesion del usuario
    test: false,
    saving: false,
    ///////////////////////////////////////////////////////
    //// CONSULTA PRINCIPAL
    // evento: 'agregar',
    search: "",
    data: {},
    formTitle: "",
    // componente Fomulario Colegio
    iconoFile: "",
    typefFile: "",
    disabledFile: true,
    archivosTemp: [],
    listNivel: [],
    listArea: [],
    listTipoRecurso: [
      { id: "img", descripcion: "Imágenes" },
      { id: "doc", descripcion: "Documento" },
      { id: "vid", descripcion: "Video" },
      { id: "aud", descripcion: "Audio" },
    ],
    listAcceso: [
      { id: 1, descripcion: "Público" },
      { id: 2, descripcion: "Privado" },
    ],
    //validaciones de formulario
    rul: {
      required: (value) => !!value || "Campo requerido",
      inputReq: (value) => !!value || "Campo requerido",

      imgReq: (files) => {
        if (!files || files.length === 0) {
          return "Campo requerido";
        }

        const allowedFormats = ["image/png", "image/jpeg"];

        for (const file of files) {
          if (!allowedFormats.includes(file.type)) {
            return "Formato de archivo no válido";
          }
        }

        return true; // Validation passed
      },
      // selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
      selectReq: (v) =>
        !v || v != -1 || "Debe seleccionar un campo de la lista",
      email: (value) =>
        /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) ||
        "El correo es incorrecto",
      min4: (v) => (v || "").length >= 4 || "Mínimo 4 caracteres",
      min6: (v) => (v || "").length >= 6 || "Mínimo 6 caracteres",
      min8: (v) => (v || "").length >= 8 || "Mínimo 8 caracteres",
      max10: (v) => (v || "").length <= 10 || "Máximo 10 caracteres",
      max11: (v) => (v || "").length <= 11 || "Máximo 11 caracteres",
      max12: (v) => (v || "").length <= 12 || "Máximo 12 caracteres",
      max20: (v) => (v || "").length <= 20 || "Máximo 20 caracteres",
      max30: (v) => (v || "").length <= 30 || "Máximo 30 caracteres",
      max50: (v) => (v || "").length <= 50 || "Máximo 50 caracteres",
      max60: (v) => (v || "").length <= 60 || "Máximo 60 caracteres",
      max100Mb: (v) => (v || "").length <= 100 || "Máximo 100 caracteres",
      max150: (v) => (v || "").length <= 150 || "Máximo 150 caracteres",
      max5Mb: (v) =>
        !v ||
        v.every((file) => file.size < 5000000) ||
        "El tamaño de los documento debe ser inferior a 5 MB!",
      max10Mb: (v) =>
        !v ||
        v.every((file) => file.size < 10000000) ||
        "El tamaño de los documentos debe ser inferior a 10 MB!",
    },
  }),
  //computadas
  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },
  mounted() {
    this.LoadMain();
  },
  created() {
    this.actualizarParamentro();
  },
  watch: {
    // cada vez que la pregunta cambie, esta función será ejecutada
    estadoComp() {
      if (this.estadoComp) {
        this.LoadMain();
      } else {
        //this.parametros = {}
        this.LimpiarForm();
      }
    },
  },
  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA //////////////////////
    // -- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),
    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////
    //-- cargar Parametros de inicio del componente --
    async LoadMain() {
      this.LimpiarForm();
      this.data.id_pais = this.parametros.items.id_pais;
      this.data.id_tema = this.parametros.items.id_tema;
      this.data.id_clase = this.parametros.items.id_clase;
      this.GetNivel(this.parametros.items.id_pais);
      if (this.parametros.evento == "add") {
        this.AddItem();
      }

      if (this.parametros.evento == "edit") {
        this.EditItem(this.parametros.items);
      }
    },

    AddItem() {
      this.formTitle = "Agregar recursos";
    },

    EditItem(item) {
      this.formTitle = "Editar recursos";
      this.data = item;
      this.data.id_usuario = sessionStorage.id;
      this.EventNivel(this.data);
    },

    //-------mostrar registros------------
    async GetNivel(id_pais) {
      try {
        let response = await axios.get(`/manager/nivelCkOne/pais/${id_pais}`);
        this.listNivel = response.data;
      } catch (error) {
        console.log(error);
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    async EventNivel(data) {
      let params = { id_pais: data.id_pais, id_nivel: data.id_nivel };
      try {
        const response = await axios.post("/manager/areaCkOne/pais/", params);
        this.listArea = response.data;

        if (this.listArea == "") {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "No existen Áreas creadas para éste Nivel",
            tiempo: null,
          });
        }
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },

    EventTypeResource(value) {    
      this.disabledFile = true;
      if (value) {
        this.disabledFile = false;
      }
    },

    OnArchivoChange(e) {
      if (e !== undefined) {
        this.archivosTemp = e;
      } else {
        this.archivosTemp = [];
      }
    },

    async SaveItem() {
      if (!this.$refs.formDatosResource.validate()) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe de ingresar todos los campos requeridos`,
          tiempo: null,
        });
        return;
      }
      this.saving = true;
      let formData = new FormData();
      formData.append("id_pais", this.data.id_pais);
      formData.append("id_clase", this.data.id_clase);
      formData.append("id_tema", this.data.id_tema);
      formData.append("id_nivel", this.data.id_nivel);
      formData.append("id_area", this.data.id_area);
      formData.append("id_tipo_recurso", this.data.id_tipo_recurso);
      formData.append("id_acceso", this.data.id_acceso);
      // formData.append('file_desc', this.data.file_desc)
      formData.append("id_usuario", this.data.id_usuario);
      for (let index = 0; index < this.archivosTemp.length; index++) {
        const archivo = this.archivosTemp[index];
        formData.append("archivos", archivo);
      }

      try {
        // eslint-disable-next-line no-unused-vars
        let response = {};
        if (this.parametros.evento == "add") {
          response = await axios.post(
            "/manager/fileS3/gestorContenido",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
        }
        if (this.parametros.evento == "edit") {
          response = await axios.put(
            `/manager/fileS3/gestorContenido/${this.data.id}`,
            { datos: this.data }
          );
        }
        // console.log(object);
        // console.log("asdasd",response.data);
        this.setEnviarMens({
          tipo:response.data.messageT,
          mensaje:response.data.message
        })

        // this.$nextTick(() => {
          this.$emit("reloadComp", "resource");
          this.$emit("close");
        // });
        // this.$emit("reloadComp", "resource");
        // this.$emit("close");
      } catch (error) {
        console.log(error);
      } finally {
        this.saving = false;
      }
    },

    LimpiarForm() {
      this.data = {
        id: -1,
        id_clase: -1,
        id_tema: -1,
        id_pais: -1,
        id_nivel: -1,
        id_area: -1,
        id_tipo_recurso: "",
        id_acceso: -1,
        file_desc: "",
        id_usuario: sessionStorage.id,
      };
      this.$refs.formDatosResource.resetValidation();
    },
  },
};
</script>

<style scoped></style>